<template>
    <ion-toolbar>
    <ion-buttons slot="start">
    <ion-button class="button_back" @click="goBack">
    <ion-icon name="arrow-back-outline"></ion-icon>
    </ion-button>
    </ion-buttons>
     <ion-title>
     
         <span v-if="job.convertedDate">{{ job.convertedDate }}</span>
         <span v-else>Guest Shift</span>
     </ion-title>
    </ion-toolbar>
  
  
   <div class="main_wrapper ion-padding">
     <div class="container">
       <div class="job_info_wrapper job_info_wrapper--custom">
       <div
         class="image_text_comp image_text_comp--mb"
         v-if="job.guest"
       >
         <div class="image_wrapper">
          <el-avatar
              :size="'small'"
              :shape="'square'"
              :style="{ backgroundColor: 'rgb(var(--locumate-primary-color))', color: 'white' }"
            >
            {{ getInitials(job.guest.firstName, job.guest.lastName) }}
          </el-avatar>
          <!-- <el-avatar
              :size="'small'"
              shape="square"
              :src="job.pharmacy.image"
              v-if="job.pharmacy.image"
            />
            <el-avatar
              :size="'small'"
              shape="square"
              icon="el-icon-user-solid"
              v-else
            ></el-avatar> -->
         </div>
         <div class="text_wrapper">
           <div class="main_text guest_shift_fullname">{{ job.guest.firstName }} {{ job.guest.lastName }}</div>
           <div class="additional_text additional_text_shift">
             <span><i class="el-icon-message"></i>{{ job.guest.email }}</span>
             <span><i class="el-icon-phone"></i>{{ job.guest.phone }}</span>
           </div>
         </div>
       </div>
       <div class="rate_shifts_info">
           <div class="info_wrapper">
             <div class="info_title info_title--big">Shift dates</div>
             <div class="info_value">
               <span>{{ job.convertedDate }}</span>
             </div>
           </div>
         </div>
         <el-table :data="job.shiftDatas" style="width: 100%;padding-top: 15px;">
            <el-table-column prop="date" label="Date" width="110" />
            <el-table-column prop="startTime" label="Start time" width="110" />
            <el-table-column prop="endTime" label="End Time" width="110"/>
            <el-table-column :label="isAustralia ? 'Rate (excluding super)' : 'Rate'" width="190">
              <template #default="scope">
                <span>{{ Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(scope.row.rate) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div v-if="job.confirmationDate !== null">
           <div class="info-outer">
           <div class="info_wrapper" v-if="job.notes">
             <div class="info_title info_title--big">Shift Notes</div>
             <div class="info_value  info_value-job">
               <span style="white-space: pre-line">{{ job.notes }}</span>
             </div>
           </div>
           <div v-else></div>
         </div>
       
         <el-form
           class="job_shifts_wrapper fullp"
           :model="formsData.userForm"
           :rules="formsData.userForm.rules"
           :ref="(el) => (formsData.userForm.ref = el)"
           :label-position="'top'"
           @submit.prevent="submit('userForm')"
       >
           <el-form-item :required="false" class="el-form-item-check">
             <el-checkbox v-model="formsData.userForm.acceptLocumateTc.value" disabled
               > I Accept the {{$filters.appName() }}
             </el-checkbox>
             <span class="tc-link"><router-link :to="{ name: 'terms_and_conditions_guest_shift' }"> T&C's</router-link></span>
           </el-form-item>
           <el-form-item :required="false">
             <el-checkbox v-model="formsData.userForm.acceptPharmacyTc.value" disabled
               > I Accept the <span v-if="isAustralia">Pharmacy</span><span v-else>Employer</span>
             </el-checkbox>
             <span class="tc-link"  @click="showPopup()"> T&C's</span>
           </el-form-item>
           <div v-if="guest.aphra == 1 && isAustralia">
            <div class="info_title info_title--big">AHPRA Details</div>
            <div class="info-row">
              <div class="info_title--big">AHPRA Number: </div>
               <div class="info-text">
                 <span style="white-space: pre-line">{{ guest.aphraNumber }}</span>
               </div>
            </div>
             <div class="info-row">
               <div class="info_title--big">AHPRA Expiry Date: </div>
               <div class="info-text">
                 <span style="white-space: pre-line">{{ guest.aphraExpiryDate }}</span>
               </div>
             </div>
           </div>
              <div
              class="preview_square preview_square--block  preview_square--custom"
              v-if="insuranceDocument.length"
            >
              <div class="proof-ins"> <strong>Insurance Document</strong> </div>
                <div class="el-upload-list">
                  <div class="el-upload-list__item" v-for="(file) in insuranceDocument" :key="file.url">
                    <div class="thumbnail_img el-upload-list--picture-card">
                      <div v-if="file.extension == 'pdf'">
                        <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                      </div>
                      <div v-else>
                        <img
                        class="el-upload-list__item-thumbnail"
                        :src="file.url"
                        alt=""
                      />
                      </div>
                      <span class="el-upload-list__item-actions">
                        <span
                          class="el-upload-list__item-preview"
                          @click="certPreviewModalOpen(file)"
                        >
                          <i class="el-icon-zoom-in"></i>
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
           <el-form-item >
           </el-form-item>
       </el-form>
          </div>
          <div v-else>
           <div class="guest_shift-img">
          <img
              :src="require(`@/assets/img/illustrations/pending_approval.svg`)"
              alt=""
              />
          <span>Guest Shift request is send to guest locum and waiting for approval.</span>
           </div>
          
       
          </div>
       
        </div>
     </div>
   </div>
  
   <el-dialog v-model="centerDialogVisible" title="Pharmacy T&C's" width="30%" center >
    
     <div v-if="job.guest.termsAndConditions">
       <p style="white-space: pre-line">{{ job.guest.termsAndConditions }}</p>
       <!-- {{{ job.guest.termsAndConditions }}} -->
     </div>
  
     <div  v-if="job.contractUrl">
       <div class="image_wrapper">
             <div class="download-img-wrap">
               <div class="download-img">
                 <a :href="job.contractUrl" target="_blank" download>  
                   <!-- <span class="locumate_icons locumate_icon-picture"></span> -->
                   <p class="download-btn">Download Contract <i class="el-icon-download"></i></p>
                 </a>
               </div>
              
             </div>
           </div>
     </div>
   </el-dialog>
  
   <cert-preview-modal
      :modalName="'certPreviewModal'"
      :options="certPreviewModal"
    />
  </template>
  
  <script>
  
  
  import {
   ref,
   onMounted,
   inject,
   // computed,
  } from "vue";
  import { addIcons } from "ionicons";
  import { arrowBackOutline } from "ionicons/icons";
  import formHooks from "@/hooks/form/form";
  import formValidate from "@/hooks/form/validate/validate";
  addIcons({
   "arrow-back-outline": arrowBackOutline,
  });
  import { isAustraliaRegion } from '@/helpers/region/regionHelper.js';
  
  import { useStore } from "vuex";
  import {
   useRouter,
   // useRoute
  } from "vue-router";
  import { CertPreviewModal } from "@/modals/modals";
  
  export default {
    components: {
      "cert-preview-modal": CertPreviewModal,
    },
   setup() {
     const $store = useStore();
     const $router = useRouter();
    
     const setPageClassGlobal = inject("setPageClassGlobal");
     const centerDialogVisible  = ref(false);
     let disabled = ref(true);
     let job = ref($store.getters.getGuestShiftPublicDetails);
     console.log("guest shift are",job);
     let guest = ref(job.value.guest);
     let pharmacy = ref(job.value.pharmacy);
    console.log("pharmacy", pharmacy);
    const isAustralia = isAustraliaRegion();
  
    const aphraRegistration = ref(job.value.aphraUrls);
    const insuranceDocument = ref(job.value.insuranceUrls);

    const goBack = () => {
        $router.back();
    };
  
     const $modals = inject("$modals");
      const certPreviewModal = ref({
        name: "certPrev",
        file: [],
      });
      const certPreviewModalOpen = (file) => {
        console.log("hehehhe",file)
        if(file.extension == 'pdf'){
          window.open(file.url, '_blank');
        }else{
          certPreviewModal.value.file = file;
        $modals.open("certPreviewModal", {
          file: file,
        });
      }
      };
  
  
     const formsDataArray = {
       userForm: {
         acceptLocumateTc: {
           value: true,
         },
         acceptPharmacyTc: {
           value: true,
         },
         aphraRegistration: {
           ref: null,
           value: [],
           limit: 10,
           disabled: false,
           validators: [
               {
               validator: (rule, formField, callback) => {
                   formValidate.validate(
                   rule,
                   formField,
                   "gallery",
                   callback,
                   setFormValidation
                   );
               },
               },
           ],
           errors: null,
           },
       insuranceDocument: {
       ref: null,
       value: [],
       limit: 10,
       disabled: false,
       validators: [
           {
           validator: (rule, formField, callback) => {
               formValidate.validate(
               rule,
               formField,
               "gallery",
               callback,
               setFormValidation
               );
           },
           },
       ],
       errors: null,
       },
       },
     };
  
     const showPopup = () =>{
        centerDialogVisible.value = true;
     
     }

     const getInitials = (firstName, lastName) => {
      const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : "";
      const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : "";
      return `${firstInitial}${lastInitial}`;
    };
  
     const close=()=>{
        $router.push({
            name: "auth",
          });
      }
    
  
     onMounted(() => {
       setPageClassGlobal("global_job_book_page");
       
     });
  
  
     const {
       setFormValidation,
       formsData,
     } = formHooks(formsDataArray);
     return {
       formsData,
       job,
       guest,
       disabled,
       pharmacy,
       centerDialogVisible,
       showPopup,
       aphraRegistration,
       insuranceDocument,
       certPreviewModalOpen,
       certPreviewModal,
       close,
       goBack,
       isAustralia,
       getInitials
     };
   },
  };
  </script>
  